<div *ngIf="editedUserAccessGroups">
  <p-dialog [(visible)]="editMode"
            [modal]="true"
            [style]="{ width: '40vw' }"
            (onHide)="cancelRowEdit()">
    <ng-template pTemplate="header">
      <div class="inline-flex align-items-center justify-content-center gap-2">
        <span>Редактирование логина <strong>{{editedUserAccessGroups.namestr}}</strong></span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div *ngIf="editMode">
        <p-fieldset class="col-12" legend="Database User ({{editedUserAccessGroups.SGMPERSID}})">
          <div class="grid">
            <div class="col-6">
              <app-personselector [parentCompany]="editedUserAccessGroups.SGMCLIID" [selectedID]="editedUserAccessGroups.SGMPERSID" [showClear]="false"
                                  [showLabel]="false" (selectedPersonID)="mainPersonSelected($event)" [disabled]="editedUserAccessGroups.uid != -2"></app-personselector>
            </div>
            <div class="col-6">
              <p-dropdown [options]="securityGroups" dataKey="SECGROUPID" optionLabel="SECGROUPNAME"
                          (onChange)="groupEditChange($event)"
                          [(ngModel)]="editedUserAccessGroups.group"
                          [autofocusFilter]="false"
                          tooltip="Группа доступа"
                          placeholder="Группа доступа">
              </p-dropdown>
            </div>
            <div class="col-12">
              <input pInputText type="text" [(ngModel)]="editedUserAccessGroups.SGMDESC" placeholder="Описание учетной записи" title="Описание учетной записи" class="col">
            </div>
            <div class="col-12">
              <input pInputText type="text" [(ngModel)]="editedUserAccessGroups.SGMPASSWD" placeholder="Пароль в базе данных (не используется)" title="Пароль в базе данных (не используется)" class="col" disabled>
            </div>
          </div>
        </p-fieldset>

        <p-fieldset class="col-12" legend="Keycloak User">
          <div class="grid">
            <div class="col-12">
              <app-keycloakuserselector [userAccessGroupInfo]="editedUserAccessGroups" [personToSearch]="profileToEdit" (userUpdated)="onUserUpdate($event)"></app-keycloakuserselector>
            </div>
            <div class="col-6">
              <input pInputText type="text" [(ngModel)]="editedUserAccessGroups.SGMLOGIN" placeholder="Логин сервера" title="Логин сервера" class="col">
            </div>
            <div class="col-3">
              <input pInputText type="password" [(ngModel)]="editedUserAccessGroups.SGMPASSWD" placeholder="Password" title="Password" class="col">
            </div>
            <div class="col-3">
              <input pInputText type="password" [(ngModel)]="retypePassword" placeholder="Repeat Password" title="Repeat Password" class="col">
            </div>
            <div class="col-12" *ngIf="editedUserAccessGroups.SGMPASSWD && retypePassword && editedUserAccessGroups.SGMPASSWD !== retypePassword">
              <small class="p-error">Пароли не совпадают</small>
            </div>
            <div class="col-6">
              <p-multiSelect [options]="keycloakGroups" placeholder="Группы сервера"
                             styleClass="p-column-filter p-dropdown-filter-style" [maxSelectedLabels]="3" dataKey="id"
                             (onChange)="onUserKeycloakGroupListChange($event)" [(ngModel)]="editedUserAccessGroups.keycloakGroups"
                             optionLabel="name" class="p-dropdown-filter-style" appendTo="body"
                             emptyFilterMessage="Не найдено" selectedItemsLabel="{0} групп выбрано" tooltip="Фильтр по выбранным группам">
              </p-multiSelect>
            </div>
            <div class="col-6">
              <p-multiSelect [options]="keycloakRoles" placeholder="Роли сервера"
                             styleClass="p-column-filter p-dropdown-filter-style" [maxSelectedLabels]="4" dataKey="id"
                             (onChange)="onUserKeycloakRolesListChange($event)" [(ngModel)]="editedUserAccessGroups.keycloakRoles"
                             optionLabel="name" class="p-dropdown-filter-style" appendTo="body"
                             emptyFilterMessage="Не найдено" selectedItemsLabel="{0} роли выбрано" tooltip="Фильтр по выбранным ролям">
              </p-multiSelect>
            </div>
            <div class="col-12">
              <p-checkbox class="col" [(ngModel)]="editedUserAccessGroups.keycloakLocked" [binary]="true" label="Заблокировать"></p-checkbox>
            </div>
          </div>
        </p-fieldset>
        <!-- Iterate over report servers for current user -->
        <!-- Temporary fix -->
        <div *ngIf="userLoginIdExists(editedUserAccessGroups)">
          <!--<h6>Report Server Access Configuration</h6>-->

          <div class="grid" *ngIf="editedUserAccessGroups?.reportServerAccess as serverAccess">
            <p-fieldset class="col-12" *ngFor="let server of serverAccess; let i = index"
                        legend="Report Servers: {{server.serverName}} Access for user: {{server.userName}} ({{getReportServerUserShortid(server.serverUrl, server.userName)}})"
                        title="{{ server.serverUrl }}">
              <div class="grid" *ngIf="server">
                <div class="col-6">
                  <p-multiSelect [options]="getReportServerGroups(server.serverUrl)" [(ngModel)]="server.groups" optionLabel="name" dataKey="shortid"
                                 class="p-dropdown-filter-style" styleClass="p-column-filter p-dropdown-filter-style" appendTo="body"
                                 [maxSelectedLabels]="3" (onChange)="reportServerUserGroupsChange($event)"
                                 emptyFilterMessage="Не найдено" selectedItemsLabel="{0} групп выбрано"
                                 placeholder="Группы пользователей сервера" tooltip="Фильтр по выбранным группам">
                  </p-multiSelect>
                </div>
                <div class="col-6">
                  <p-checkbox class="col" [(ngModel)]="server.readAccess" [binary]="true" label="Разрешить доступ к серверу отчетов" (onChange)="onServerAccessChange(server, i)"></p-checkbox>
                </div>
                <div class="col-6">
                  <p-checkbox class="col" [(ngModel)]="server.isAdmin" [binary]="true" label="Административный доступ" (onChange)="onServerAccessChange(server, i)" [disabled]="disallowSetAdminRights"></p-checkbox>
                </div>
                <div class="col-6">
                  <p-checkbox class="col" [(ngModel)]="server.editAccess" [binary]="true" label="Разрешить редактирование на сервере отчетов" (onChange)="onServerAccessChange(server, i)"></p-checkbox>
                </div>
              </div>
              <div class="grid" *ngIf="1">
                <div class="col m-1">Username: {{ server.userName || 'Not created' }}</div>
                <div class="col m-1">Keycloak Login: {{ server.kcLogin }}</div>
              </div>
            </p-fieldset>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button label="Отменить"
                [text]="true"
                severity="primary"
                (onClick)="cancelRowEdit()" />
      <p-button label="Сохранить"
                severity="primary"
                [disabled]="canSaveUserInfo"
                (onClick)="saveRowEdit()" />
    </ng-template>
  </p-dialog>
</div>

<!-- Ultimate confirmation to delete user -->
<div *ngIf="selectedUserAccessGroups">
  <p-dialog [(visible)]="askToDelete"
            [modal]="true"
            [style]="{ width: '25vw' }"
            (onHide)="askToDelete=false">
    <ng-template pTemplate="header">
      <div class="inline-flex align-items-center justify-content-center gap-2">
        <h5>
          <span class="p-error">Подтверждение удаления пользователя из системы <bold>{{selectedUserAccessGroups.namestr}}</bold></span>
        </h5>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <p-fieldset legend="Выбрано удаление в других службах" class="col-12" *ngIf="selectedUserAccessGroups.SGMLOGIN">
        <div class="grid">
          <p-checkbox class="col ml-2 mt-2" [(ngModel)]="doDeleteKeycloakUser" [binary]="true" label="Сервер авторизации" [disabled]="true"></p-checkbox>
          <p-checkbox class="col ml-2 mt-2" [(ngModel)]="doRemoveReportServerUsers" [binary]="true" label="Сервер(а) отчетов" [disabled]="true"></p-checkbox>
        </div>
      </p-fieldset>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button label="Отменить"
                [text]="true"
                severity="primary"
                (onClick)="cancelToDelete()" />
      <p-button label="Удалить"
                severity="primary"
                (onClick)="iAmSureToDelete(selectedUserAccessGroups)" />
    </ng-template>
  </p-dialog>
</div>

<!-- Initial confirmation to delete user -->
<div *ngIf="selectedUserAccessGroups">
  <p-dialog [(visible)]="toDelete"
            [modal]="true"
            [style]="{ width: '30vw' }"
            (onHide)="toDelete=false">
    <ng-template pTemplate="header">
      <div class="inline-flex align-items-center justify-content-center gap-2">
        <span>Удаление пользователя из системы <bold>{{selectedUserAccessGroups.namestr}}</bold></span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <p-fieldset legend="Так же удалить в других службах" class="col-12" *ngIf="selectedUserAccessGroups.SGMLOGIN">
        <div class="grid">
          <p-checkbox class="col ml-2 mt-2" [(ngModel)]="doDeleteKeycloakUser" [binary]="true" label="Сервер авторизации"></p-checkbox>
          <p-checkbox class="col ml-2 mt-2" [(ngModel)]="doRemoveReportServerUsers" [binary]="true" label="Сервер(а) отчетов"></p-checkbox>
        </div>
      </p-fieldset>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button label="Отменить"
                [text]="true"
                severity="primary"
                (onClick)="cancelToDelete()" />
      <p-button label="Удалить"
                severity="primary"
                (onClick)="confirmToDelete(selectedUserAccessGroups)" />
    </ng-template>
  </p-dialog>
</div>

<p-toolbar styleClass="">
  <ng-template pTemplate="left">
    <p-button label="New" icon="pi pi-plus" class="mr-2" severity="primary" (onClick)="onNewUserAccess($event)"
              [disabled]="editing" pTooltip="Добавить пользователя" tooltipPosition="top"></p-button>
    <p-button label="Copy" icon="pi pi-copy" class="mr-2" severity="primary" (onClick)="onCopyUserAccess($event)" *ngIf="selectedUserAccessGroups"
              [disabled]="editing || thereIsNoSelection" pTooltip="Скопировать текущего пользователя" tooltipPosition="top"></p-button>
    <!--<p-button label="Delete" icon="pi pi-trash" class="mr-2" severity="danger" (onClick)="deleteUserAccess($event)" *ngIf="selectedUserAccessGroups"
              [disabled]="editing || thereIsNoSelection" pTooltip="Удалить выбранного пользователя {{selectedUserAccessGroups.namestr}}" tooltipPosition="top"></p-button>-->
    <p-button label="Delete 1" icon="pi pi-trash" class="mr-2" severity="danger" *ngIf="toDelete" [disabled]="true"></p-button>
    <p-button label="Delete 2" icon="pi pi-trash" class="mr-2" severity="danger" *ngIf="askToDelete" [disabled]="true"></p-button>

  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-undo" label="Сбросить фильтр" class="mr-2" (onClick)="clearOrResetTableFilter($event)"
              pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>
    <p-button icon="pi pi-reset" label="Обновить" class="" (onClick)="reloadTable($event)"
              pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<div *ngIf="userAccessGroups else uagLoading">

  <p-table id="UAG1" #UAG1 [value]="userAccessGroups"
           [paginator]="true"
           [rows]="rows"
           [totalRecords]="totalRecords"
           [loading]="loading"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,25,50]"
           currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} записей"
           sortMode="single"
           [rowHover]="true"
           [resizableColumns]="true"
           selectionMode="single"
           [(selection)]="selectedUserAccessGroups"
           (onRowSelect)="onRowSelect($event)"
           (onRowUnselect)="onRowUnselect($event)"
           editMode="row"
           dataKey="SGMPASSWD"
           (onFilter)="filterUagTable($event)"
           stateStorage="local"
           stateKey="usersAccessGroups-state"
           (onStateSave)="onStateSave($event)"
           (onStateRestore)="onStateRestore($event)"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
    <ng-template #hdr pTemplate="header">
      <tr>
        <th pResizableColumn style="text-align:center; width:8rem">...</th>
        <th pResizableColumn style="text-align:right; width:12rem"><i></i></th>
        <th pResizableColumn style="width:24%" pSortableColumn="SGMPERSID">Пользователь <p-sortIcon [field]="namestr"></p-sortIcon></th>
        <th pResizableColumn style="width:auto" pSortableColumn="SGMLOGIN">Логин сервера <p-sortIcon [field]="SGMLOGIN"></p-sortIcon></th>
        <!--<th pResizableColumn width="20%">Группы сервера </th>
        <th pResizableColumn width="20%">Роли сервера </th>-->
        <th pResizableColumn style="width:20%" pSortableColumn="SGMGROUPID">Группа доступа <p-sortIcon [field]="SGMGROUPID"></p-sortIcon></th>
        <th pResizableColumn style="width:20%" pSortableColumn="SGMDESC">Описание <p-sortIcon [field]="SGMDESC"></p-sortIcon></th>
      </tr>
      <tr>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по пользователю" class="p-dropdown-filter-style" [(ngModel)]="userFilter"
                   (input)="UAG1.filter($event.target.value, 'namestr', 'contains')" (onChange)="onUserLoginChange($event)">
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по логину сервера" class="p-dropdown-filter-style" [(ngModel)]="loginFilter"
                   (input)="UAG1.filter($event.target.value, 'SGMLOGIN', 'contains')" (change)="onUserLoginChange($event)">
          </div>
        </th>

        <!--<th style="overflow: visible !important; ">
          <div class="flex p-jc-between align-items-center">
            <p-multiSelect [options]="keycloakGroups" placeholder="Группы сервера"
                            styleClass="p-column-filter p-dropdown-filter-style" [maxSelectedLabels]="2" dataKey="id"
                            (onChange)="onKeycloakGroupListChange($event)" [(ngModel)]="selectedFilterGroups" optionLabel="name" class="p-dropdown-filter-style"
                            emptyFilterMessage="Не найдено" selectedItemsLabel="{0} групп выбрано" tooltip="Фильтр по выбранным группам">
            </p-multiSelect>
          </div>
        </th>

        <th style="overflow: visible !important; ">
          <div class="flex p-jc-between align-items-center">
            <p-multiSelect [options]="keycloakRoles" placeholder="Роли сервера"
                            styleClass="p-column-filter p-dropdown-filter-style" [maxSelectedLabels]="2" dataKey="id"
                            (onChange)="onKeycloakRolesListChange($event)" [(ngModel)]="selectedFilterKeycloakRoles" optionLabel="name" class="p-dropdown-filter-style"
                            emptyFilterMessage="Не найдено" selectedItemsLabel="{0} групп выбрано" tooltip="Фильтр по выбранным группам">
            </p-multiSelect>
          </div>
        </th>-->

        <th style="overflow: visible !important; ">
          <div class="flex p-jc-between align-items-center">
            <p-multiSelect [options]="securityGroups" placeholder="Группы доступа"
                           styleClass="p-column-filter p-dropdown-filter-style" [maxSelectedLabels]="2" dataKey="SECGROUPID"
                           (onChange)="onGroupListChange($event)" [(ngModel)]="selectedFilterKeycloakGroups" optionLabel="SECGROUPNAME" class="p-dropdown-filter-style"
                           emptyFilterMessage="Не найдено" selectedItemsLabel="{0} групп выбрано" tooltip="Фильтр по выбранным группам">
            </p-multiSelect>
          </div>
        </th>

        <th>
          <div class="flex p-jc-between align-items-center">
            <input pInputText type="text" placeholder="Поиск по описанию" class="p-dropdown-filter-style" [(ngModel)]="descFilter"
                   (input)="UAG1.filter($event.target.value, 'SGMDESC', 'contains')" (onChange)="onUserDescChange($event)">
          </div>
        </th>

      </tr>
    </ng-template>

    <ng-template #bd pTemplate="body" let-uag let-editing="editing" let-rii="rowIndex">
      <tr [pSelectableRow]="uag" style="height: 3.5rem;">
        <!-- <tr [pEditableRow]="uag" [pSelectableRow]="uag" style="height: 3.5rem;"> -->
        <td style="text-align:right">

          <p-button *ngIf="userLoginIdExistsOrIsEmpty(uag) && !editing && !editMode && selectedRow(uag)" icon="pi pi-pencil" (onClick)="onUagRowEditInit(uag)"
                    [disabled]="!canEditUserRow(uag)"
                    [pTooltip]="getEditDisabledTooltip(uag)"
                    class="p-button-rounded mt-2 mb-2 mr-2" />

          <p-button *ngIf="(selectedUserAccessGroups==uag) && !editing && !editMode" icon="pi pi-trash" severity="danger" (onClick)="deleteUserAccess(uag)"
                    [disabled]="!canEditUserRow(uag)"
                    [pTooltip]="getEditDisabledTooltip(uag)"
                    tooltipPosition="top"
                    class="p-button-rounded mt-2 mb-2 mr-2"></p-button>

          <!--<button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow ></button>
  <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onUagRowEditSave(uag)" [disabled]="sgmExists(uag)"
          class="p-button-rounded p-button-text p-button-success mr-2 mt-2 mb-2"
          #inp></button>
  <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onUagRowEditCancel(uag, rii)"
          class="p-button-rounded p-button-text p-button-danger mt-2 mb-2"></button>-->
        </td>
        <td style="text-align:right">
          <div *ngIf="userLoginIdExists(uag)">
            <span ngif="uag.reportServerUser">
              <span *ngFor="let server of uag.reportServerAccess; let i = index">
                <i class="pi pi-shield ml-1" [title]="'Admin Access on ' + server.serverUrl" *ngIf="server.isAdmin"></i>
                <i class="pi pi-eye ml-1" [title]="'Read Access on ' + server.serverUrl" *ngIf="server.readAccess"></i>
                <i class="pi pi-pencil ml-1" [title]="'Edit Access on ' + server.serverUrl" *ngIf="server.editAccess"></i>
              </span>
            </span>
            <i class="pi pi-lock ml-1" title="User Login Locked" *ngIf="uag.keycloakLocked"></i>&nbsp;
            <i class="pi pi-check ml-1" title="User Exists"></i>
          </div>
        </td>

        <!--        <td style="overflow: visible !important; text-overflow: ellipsis !important;">-->
        <td [class.visible-overflow]="editing" [class.text-overflow]="!editing">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-personselector [parentCompany]="uag.SGMCLIID" [selectedID]="uag.SGMPERSID" [showClear]="false"
                                  [showLabel]="false" (selectedPersonID)="mainPersonSelected($event)" [style]="{'width':'100%'}"></app-personselector>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="flex align-items-center" style="justify-content: space-between;">
                <div>
                  <span *ngIf="uag"><a [routerLink]="['/edit-person', uag.SGMPERSID]">{{uag.namestr}}</a></span>
                </div>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <!--        <td style="overflow: visible !important; text-overflow: ellipsis !important;" >-->
        <td [class.visible-overflow]="editing" [class.text-overflow]="!editing">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-keycloakuserselector [userAccessGroupInfo]="uag" [personToSearch]="profileToEdit" (userUpdated)="onUserUpdate($event)" [style]="{'width':'100%'}"></app-keycloakuserselector>

              <!-- <input pInputText type="text" [(ngModel)]="uag.SGMLOGIN" [style]="{'width':'100%'}"> -->
            </ng-template>
            <ng-template pTemplate="output">
              <span *ngIf="uag && uag.group">{{uag.SGMLOGIN}}</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <!--<td [class.visible-overflow]="editing" [class.text-overflow]="!editing">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="field">
                <p-multiSelect [options]="keycloakGroups" placeholder="Группы сервера"
                                styleClass="p-column-filter p-dropdown-filter-style" [maxSelectedLabels]="2" dataKey="id"
                                (onChange)="onUserKeycloakGroupListChange($event)" [(ngModel)]="uag.keycloakGroups" optionLabel="name" class="p-dropdown-filter-style"
                                emptyFilterMessage="Не найдено" selectedItemsLabel="{0} групп выбрано" tooltip="Фильтр по выбранным группам">
                </p-multiSelect>
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              <span style="text-overflow: ellipsis" *ngIf="uag && uag.group">{{getKeycloakGroupNamesFromList(uag.keycloakGroups)}}</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <td [class.visible-overflow]="editing" [class.text-overflow]="!editing">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="field">
                <p-multiSelect [options]="keycloakRoles" placeholder="Роли сервера"
                                styleClass="p-column-filter p-dropdown-filter-style" [maxSelectedLabels]="2" dataKey="id"
                                (onChange)="onUserKeycloakRolesListChange($event)" [(ngModel)]="uag.keycloakRoles" optionLabel="name" class="p-dropdown-filter-style"
                                emptyFilterMessage="Не найдено" selectedItemsLabel="{0} роли выбрано" tooltip="Фильтр по выбранным ролям">
                </p-multiSelect>
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              <span style="text-overflow: ellipsis" *ngIf="uag && uag.group">{{getKeycloakGroupNamesFromList(uag.keycloakRoles)}}</span>
            </ng-template>
          </p-cellEditor>
        </td>-->

        <td [class.visible-overflow]="editing" [class.text-overflow]="!editing">
          <p-cellEditor>
            <
            <ng-template pTemplate="input">
              <
              <div class="field">
                <p-dropdown [options]="securityGroups" dataKey="SECGROUPID" optionLabel="SECGROUPNAME"
                            (onChange)="groupEditChange($event)"
                            [(ngModel)]="uag.group"
                            [autofocusFilter]="false"
                            placeholder="Группа доступа">
                </p-dropdown>
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              <span style="text-overflow: ellipsis" *ngIf="uag && uag.group">{{uag.group.SECGROUPNAME}}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td style="overflow: visible !important;">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <div class="field">
                <input pInputText type="text" [(ngModel)]="uag.SGMDESC" [style]="{'width':'100%'}">
              </div>
            </ng-template>
            <ng-template pTemplate="output">
              <span style="text-overflow: ellipsis" *ngIf="uag && uag.group">{{uag.SGMDESC}}</span>
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr style="height: 15vw">
        <td colspan="5">нет данных для загрузки</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #uagLoading>
  <p>Информация загружается...</p>
</ng-template>
